import { CloseIcon } from "@/atoms/Icons";

export default function VideoModal({ onClose, src, hasYTShorts }) {
  return (
    <div className={`iframe-container ${hasYTShorts && "hasYTShorts"}`}>
      <div className="iframe-wrapper ps-r">
        <iframe
          src={src}
          title="YouTube Video Player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
        <button className="close-btn ps-a" onClick={onClose}>
          <CloseIcon color="#FFFFFF" />
        </button>
      </div>
      <style jsx>{`
        .iframe-container {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 90%;
          height: 540px;
          max-width: 768px;
          min-width: 300px;
        }
        .iframe-wrapper {
          width: 100%;
          height: 100%;
        }
        .close-btn {
          top: -36px;
          right: 0;
        }
        @media (max-width: 425px) {
          .iframe-container {
            max-width: 335px;
            height: 320px;
          }
        }
        @media (min-width: 1200px) {
          .iframe-container {
            max-width: 1280px;
            height: 720px;
          }
          .iframe-container.hasYTShorts {
            max-width: 354px;
            height: 630px;
          }
          .close-btn {
            right: -36px;
            top: unset;
          }
        }
        .iframe-container .iframe-wrapper iframe {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      `}</style>
    </div>
  );
}
